// import React from 'react';
// import {graphql} from 'react-apollo';
// import {flowRight as compose} from 'lodash';

// import queries from '../../../../../src/utils/queries'

import claseServCli from '../../../../functions/claseservcli';
// import getNumDiasMes from '../../../../functions/getnumdiasmes';
import updColeccSI_ID from '../../../../functions/updColeccSI_ID';
import updColeccMANY from '../../../../functions/updColeccMANY';
import updColeccNO_ID from '../../../../functions/updColeccNO_ID'
import argsHc from '../../../../functions/argshc';
import argsEdCliOS from '../../../../functions/argsedclios.js';

import ncArgsNC from './ncargsnc';
import ncArgsMc from './ncargsmc';
// import rpvalidar from './rpvalidar';
// import rpArgsMvp from './rpargsmvp';
// import rpArgsPc from './rpargspc';
// import rpArgsMc from './rpargsmc';
// import rpArgsRx from './rpargsrx';


// import jsPDF from 'jspdf';
// import 'jspdf-autotable';

const MainNC = async (elementoArch, clienteSel, lista4, lista4ConFra, listFactDetN, editSeqfindOneAndUpdate, createNotasDebCre,
  editNotasDebCreUpdDoc, createHistClienteMany, createMovClientes, editMovClientes, editCliente, fechaHoraHoy, valorparaPermRX) => {

  const nextVal = async (name) => {
    const argsUpd = {
      coleccion: name,
    }
    const response = await editSeqfindOneAndUpdate({
      variables: argsUpd
    });
    return response.data.editSeqfindOneAndUpdate.seq
  }

  //ACTUALIZAR BD
  const crudBD = async (operacionCRUD, args, i)=>{
    if(args.ctrlCampo === 'CRUD'){
        const {data} = await operacionCRUD({
        variables: args
      });
//Se utiliza para traer el _id del documento creado
      if(args.ctrl_id === 'SI_ID'){
        if(Object.values(data)[0]._id){
          return Object.values(data)[0]._id
        }else{
          return 0
        }
      }
    }else{
      if(args.ctrlCampo === "MANY"){
        await operacionCRUD({
          variables: args
        });
      }
    }
  }

  const updColecc = async (crudColecc, argsCrud, totDocCRUD)=>{
      let codigo = 0
      if(argsCrud[0].ctrl_id === 'SI_ID'){
        codigo = await crudBD(crudColecc[0], argsCrud[0], 0)
      }else{
        await crudBD(crudColecc[0], argsCrud[0], 0)
      }
      if(codigo!==0){
        for(let i=1; i<totDocCRUD; i++){
          argsCrud[i]._id = codigo
        }
      }
      for(let i=1; i<totDocCRUD; i++){
        await crudBD(crudColecc[i], argsCrud[i], i)
      }
    }
// console.log(lista4)
  let saldoPendiente = clienteSel.saldoPendiente
  let userLogin = sessionStorage.getItem('userLogin')
  let contrato = elementoArch.contrato
  let valor = elementoArch.valor
  let fechaHoy = fechaHoraHoy.substr(0, 10)
  let numDX = clienteSel.numeroOdeDX

//ACTUALIZAR SALDO CLIENTE
//Coleccion a editar
  let tipoAct = "EditarCliOdeS", _id = clienteSel._id, estadoCliente = clienteSel.estadoCliente
  let cargoMensual = clienteSel.cargoMensual
  let saldoClCli = parseInt(saldoPendiente, 10) - parseInt(valor, 10)
  let saldoCl = parseInt(saldoPendiente, 10)

  let colecc = argsEdCliOS(tipoAct, _id, estadoCliente, cargoMensual, saldoClCli)
  let actColecc = colecc.actColecc

//Actualizar base de datos
  let updColNO_ID = updColeccNO_ID(actColecc, editCliente)
  await updColecc(updColNO_ID.crudColecc, updColNO_ID.argsCrud, updColNO_ID.totDocCRUD)
//FIN ACTUALIZAR SALDO CLIENTE

let numeroNota = ""

//POR CADA FACTURA
  for(let i=0; i<lista4ConFra.length; i++){
    // console.log(lista4ConFra[i], listFactDetN)
    let listFactDetN_F = await listFactDetN.filter(elemento => elemento.numeroFra===lista4ConFra[i].numeroFra)
// console.log(contrato, listFactDetN_F)
    let valorNCFact = 0
    for(let j=0; j<listFactDetN_F.length; j++){
      valorNCFact += listFactDetN_F[j].nuevoValor
    }
    valorNCFact -= listFactDetN_F[0].valorNC
    if(valorNCFact>valor){
      valorNCFact = valor
    }
    valor -= valorNCFact
    saldoCl -= valorNCFact
    if(valorNCFact>0){
      // console.log(contrato, valorNCFact)
      numeroNota = await nextVal('ncs')
      numeroNota = numeroNota.toString()
      let descripcion = "Nota Credito"
      let origen = `Nota Credito ${numeroNota}`
      let numeroFra = "", idRangoFact = "", valorNotaFact = 0
      // if(lista4ConFra[i].numeroFra){
      numeroFra = lista4ConFra[i].numeroFra
      idRangoFact = listFactDetN_F[0].idRangoFact
      valorNotaFact = listFactDetN_F[0].valorNC + valorNCFact
      origen = `Nota Credito ${numeroNota} a factura ${numeroFra}`
  // console.log(origen)

  //Coleccion HISTCLIENTES
  //Documento para coleccion
      let relacion = numeroNota, movimiento = "Nota", detalle = `A factura ${numeroFra}`
      let colecc = argsHc(contrato, relacion, valorNCFact, userLogin, descripcion, detalle, movimiento, fechaHoraHoy)
      let creaColecc = colecc.creaColecc

  //Actualizar base de datos
      let creaColeccMany = [], creaColeccMany1 = []
      creaColecc.forEach((elemento, ii) => {
        creaColeccMany.push(elemento)
      })
      creaColeccMany1.push({histcliente: creaColeccMany})

      let updColMANY = updColeccMANY(creaColeccMany1, createHistClienteMany)
      await updColecc(updColMANY.crudColecc, updColMANY.argsCrud, updColMANY.totDocCRUD)
  //FIN Coleccion HISTCLIENTES

  //Coleccion NOTAS CREDITO
  //Documento para coleccion
  // console.log(listFactDetN_F)
      let tipoNota = "NC"
      colecc = ncArgsNC(contrato, tipoNota, elementoArch.observacNota, numeroNota, valorNCFact, fechaHoraHoy, numeroFra,
        idRangoFact, listFactDetN_F, valorNotaFact)
      creaColecc = colecc.creaColecc
      let movColecc = colecc.movColecc
  // console.log(creaColecc, movColecc)
  //Actualizar base de datos
      let updColSI_ID = updColeccSI_ID(creaColecc, movColecc, createNotasDebCre, editNotasDebCreUpdDoc)
      // console.log(updColSI_ID.argsCrud)
      await updColecc(updColSI_ID.crudColecc, updColSI_ID.argsCrud, updColSI_ID.totDocCRUD)
  //FIN Coleccion NOTAS CREDITO

  //Coleccion MOVCLIENTES
      creaColecc = []
  //traer clase si todos los servicios de la tarifa son de la misma clase
      let claseServSig = claseServCli(clienteSel.tarifa.codigoTarifa, clienteSel.tarifa.servicios)

      let valorAntesImptos = 0, nuevoValorNota = valorNCFact
      listFactDetN_F.forEach((elemento1, ii) => {
        let nuevoValor = elemento1.nuevoValor
        if(nuevoValorNota<=elemento1.nuevoValor){
          nuevoValor = nuevoValorNota
          nuevoValorNota = 0
        }else{
          nuevoValorNota -= nuevoValor
        }
        let valorDet = 0, valorImpto = 0, porcImpto = 0
        porcImpto = elemento1.porcImpto
        valorDet = Math.round(nuevoValor / ((100 + porcImpto) / 100))
        valorImpto = nuevoValor - valorDet
        valorAntesImptos += valorDet
      })

      let valorMC = valorNCFact * -1
      let valorAntesImptosMC = valorAntesImptos * -1
      let valorPag = valorMC
      let ultNC = "N"
      if(i===lista4ConFra.length-1||valor<=0){
        ultNC="S"
      }
      let argsAdd = {
        "contrato": contrato,
        "fechaMov": fechaHoy,
        "tipo": "C",
        "subTipo": tipoNota,
        "procesado": "S",
        "nombreResumido": origen,
        "descripcionServicio": elementoArch.observacNota,
        "descrClaseServ": claseServSig,
        "concepto": origen,
        "origen": origen,
        "saldoCliente": saldoCl,
        "valorTotal": valorMC,
        "valorAntesImptos": valorAntesImptosMC,
        "documento": numeroNota,
        "valorPagado": valorPag,
        "valorPendiente": valorMC - valorPag,
        "numeroOdeDX": 0,
        "fechaCreate": fechaHoraHoy,
        "numeroCE": ultNC
      };
      creaColecc.push(argsAdd)
      // console.log(argsAdd)
      //Actualizar base de datos
      updColNO_ID = updColeccNO_ID(creaColecc, createMovClientes)
      await updColecc(updColNO_ID.crudColecc, updColNO_ID.argsCrud, updColNO_ID.totDocCRUD)
      //FIN Coleccion MOVCLIENTES
      if(valor<=0){
        i = lista4ConFra.length
      }
    }
  }
  //FIN POR CADA FACTURA
  // console.log(saldoCl)
  valor = elementoArch.valor

  let hacerRX = false

  //Actualizar coleccion MOVCLIENTES cuando saldoCl<=0
  actColecc = []
  if(saldoCl<=0){
    hacerRX = true
    if(numDX===0){
      hacerRX = false
    }

    lista4.forEach((elemento1, ii) => {
      let argsUpd = {
        "contrato": contrato,
        "_id": elemento1._id,
        "procesado": elemento1.procesado,
        "concepto": elemento1.concepto,
        "numeroFra": elemento1.numeroFra,
        "numeroRC": elemento1.numeroRC,
        "numeroCE": elemento1.numeroCE,
        "numeroOdeDX": elemento1.numeroOdeDX,
        "fechaUltPago": elemento1.fechaUltPago,
        "valorUltPago": elemento1.valorUltPago,
        "documento": elemento1.documento,
        "valorPagado": elemento1.valorTotal,
        "valorPendiente": 0
      }
      actColecc.push(argsUpd)
    })
    if(actColecc.length>0){
//Actualizar base de datos
      updColNO_ID = updColeccNO_ID(actColecc, editMovClientes)
      await updColecc(updColNO_ID.crudColecc, updColNO_ID.argsCrud, updColNO_ID.totDocCRUD)
    }
//FIN Actualizar coleccion MOVCLIENTES cuando saldoCl<=0
  }else{
//Actualizar coleccion MOVCLIENTES cuando saldoCl>0
//Coleccion a editar
    colecc = ncArgsMc(contrato, valor, lista4, valorparaPermRX, numDX)
    let actColecc = colecc.actColecc
    hacerRX = colecc.hacerRX

//Actualizar base de datos
    updColNO_ID = updColeccNO_ID(actColecc, editMovClientes)
    await updColecc(updColNO_ID.crudColecc, updColNO_ID.argsCrud, updColNO_ID.totDocCRUD)
//FIN Actualizar coleccion MOVCLIENTES cuando saldoCl>0
  }

  const contratoNC = {contrato, hacerRX, numeroNota}
  // console.log(contrato)
  return contratoNC
}

export default MainNC

// export default compose(
//   // graphql(queries.query.allMovClientes, {name:'allMovClientes', options: (props) => {return {variables: {contrato: "12", orden: '_id'}}}}),

//   // graphql(queries.mutation.editOdeS, {name:'editOdeS'}),

// )(MainNC)
